import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTr = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 64 80",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		fill: "none",
		fillRule: "evenodd",
		children: [/* @__PURE__ */ _jsxs("g", {
			transform: "translate(3 50)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M40.618-1l-3 6h-3.689a6.98 6.98 0 01-1.98 3.95A6.978 6.978 0 0127 11a6.977 6.977 0 01-4.856-1.958A6.985 6.985 0 0120.1 5.185h0l-3.177-.143A6.981 6.981 0 0114.95 8.95 6.978 6.978 0 0110 11a6.977 6.977 0 01-4.856-1.958A6.985 6.985 0 013.096 5.16h0L.956 5a1.994 1.994 0 01-1.37-.586A1.994 1.994 0 01-1 3h0v-4h41.618z",
					stroke: "#0D0E10",
					strokeWidth: 2
				}),
				/* @__PURE__ */ _jsx("circle", {
					fill: "#0D0E10",
					cx: 10.63,
					cy: 5,
					r: 2
				}),
				/* @__PURE__ */ _jsx("circle", {
					fill: "#0D0E10",
					cx: 27.63,
					cy: 5,
					r: 2
				})
			]
		}), /* @__PURE__ */ _jsx("rect", {
			stroke: "#0D0E10",
			strokeWidth: 2,
			x: 1,
			y: 21,
			width: 62,
			height: 28,
			rx: 2
		})]
	})
});
export default SvgTr;
